import { toast } from "react-toastify";
import * as XLSX from "xlsx";

function getDefaultValue(parameter) {
  if (
    parameter.type === "numericslider" ||
    parameter.type === "numeric" ||
    parameter.type === "percentslider" ||
    parameter.type === "percent"
  ) {
    return 0;
  } else return "";
}

export function exportFdesFormToXlsx(fdesParameterGroups, fields, calculName) {
  const parameters = fdesParameterGroups
    .filter((group) => !group.isGeneralParameter)
    .map((group) => group.parameters)
    .flat(1)
    .filter((param) => param.visible !== false)
    .map((parameter) => ({
      ParamGroup: parameter.group,
      ParamLib: parameter.name,
      ParamId: parameter.paramId,
      Value:
        fields.find((x) => x.paramId === parameter.paramId)?.value?.label ||
        getDefaultValue(parameter),
    }));

  try {
    const ws = XLSX.utils.json_to_sheet(parameters);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${calculName}-params.xlsx`);

    toast.success("Export du fichier terminé");
  } catch {
    toast.error("Erreur lors de l'export du fichier");
  }
}

export function importFdesFormFromXlsx(
  files,
  updateFields,
  isAuto,
  activeFdesId,
) {
  if (files.length === 0) {
    toast.error("Aucun fichier sélectionné");
    return;
  }
  const reader = new FileReader();
  reader.readAsArrayBuffer(files[0]);
  reader.addEventListener("load", function (e) {
    const ab = e.target.result;
    const wb = XLSX.read(ab, {
      type: "array",
      cellDates: true,
      cellNF: false,
      cellText: false,
    });
    const firstSheetName = wb.SheetNames[0];
    const ws = wb.Sheets[firstSheetName];
    const data = XLSX.utils.sheet_to_json(ws, {
      raw: false,
      dateNF: "dd/mm/yyy",
    });
    updateFields(data, isAuto, activeFdesId);
  });
}
